// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function(){
  return require('./_object-gopn-ext').f;
});


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es6.object.get-own-property-names.js
// module id = 64
// module chunks = 0